import { render, staticRenderFns } from "./Solicitudes_factoring.vue?vue&type=template&id=3018c2aa&scoped=true&"
import script from "./Solicitudes_factoring.vue?vue&type=script&lang=js&"
export * from "./Solicitudes_factoring.vue?vue&type=script&lang=js&"
import style0 from "./Solicitudes_factoring.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Solicitudes_factoring.vue?vue&type=style&index=1&id=3018c2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018c2aa",
  null
  
)

export default component.exports